import classes from "../../scss/SectionTilesList.module.scss";
import { v4 as uuid } from "uuid";
import { decodeEntities } from "@wordpress/html-entities";

export default function SectionTilesList({ list, className = "" }) {
  return (
    <ul className={`${classes.list} ${className}`}>
      {list.map((item) => (
        <li
          key={uuid()}
          className={classes.list__item}
          dangerouslySetInnerHTML={{
            __html: decodeEntities(item),
          }}
        />
      ))}
    </ul>
  );
}
